import styled from "styled-components";
import { IDragProps, IHandsignWrapperProps } from "./interfaces";
import { aspectRatio as ar } from "../../../../../common/parameters";

export const DragHolder = styled.div`
    position: absolute;
    top: 0;
`;

export const Drag = styled.div<IDragProps>`
    border-radius: 4px;
    position: absolute;
    margin: 2px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    box-shadow: 0 0 6px 0 ${p => p.theme.c.blackShadow2}, 0 0 6px 0 ${p => p.theme.c.blackShadow2} inset;
    text-shadow: 0 0 4px ${p => p.theme.c.blackShadow4};
    cursor: pointer;
    user-select: none;
    border-radius: 80% 40%;
    transform: scale(2);
    
    background-color: ${p => (p.coloring && p.solfaShort ? p.theme.c.solfa[p.solfaShort] : p.theme.c.score)};

    &.Incorrect {
        background-color: ${p => p.theme.c.incorrect} !important;
    }
    &.Correct {
        background-color: ${p => p.theme.c.correct} !important;
    }
`;


export const Drop = styled.div`
    position: absolute;
    background-color: ${p => p.theme.c.disabled};
    border-radius: 80% 40%;
    margin: 2px;
    transform: scale(2);
    transition: background-color 300ms;
    &.Playing {
        background-color: ${p => p.theme.c.playLight};
    }
`;

export const Ledger = styled.div`
    position: absolute;
    transform: scale(2);
    margin-left: 2px;
    background-color: ${p => p.theme.c.blackShadow35};
`;

export const Modifier = styled.div`
    position: absolute;
    span {
        opacity: 0.5;
        color: ${p => p.theme.c.black};
        pointer-events: none;
        font-size: inherit;
    }
`;


export const HandsignWrapper = styled.div<IHandsignWrapperProps>`
    position: absolute;
    top: ${p => -p.lineDistance * 0.2}px;
    left: ${p => -p.lineDistance * 0.2 + 2}px;
    svg {
        width: ${p => p.lineDistance * 0.85}px;
    }

    svg .stroke {
        fill: ${p => p.theme.c.score};
    }

    svg .sleeve {
        fill: ${p => p.theme.c.white};
    }
    /* stylelint-disable */
    svg .fill {
        /* stylelint-enable */
        fill: ${p =>
                p.coloring && p.solfaShort
                ? p.theme.c.solfa[p.solfaShort]
                : `#${p.color}`};
    }

    &.Incorrect {
        svg .fill {
            fill: ${p => p.theme.c.incorrect}
        }
    }
    &.Correct {
        svg .fill {
            fill: ${p => p.theme.c.correct}
        }
    }
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;

    img {
        width: ${ar.width}px;
        height: ${ar.height}px;
        display: block;
    }
`;

export const DoClef = styled.div`
    position: relative;
    font-weight: 400;
    color: ${p => p.theme.c.black};
    height: 0;
`;

export const ClefLedger = styled.div`
    position: absolute;
    background-color: ${p => p.theme.c.black};
`;

export const ClefLedgerHolder = styled.div`
    position: relative;
`;
